import { CHANGE_CURRENT_PROJECT_PAGE, PROJECT_LAUNCH_LIST, SEARCH_JOBS, SET_PROJECT_ITEMS_PER_PAGE, PROJECT_STATUS_FILTER, VIEW_LAUNCH_DETAILS, CHANGE_VIEW_LAUNCH_TAB, PROJECT_RENEWAL_LIST} from "../actions/projectAction";




const initialState = {
  projectLaunchListing: [],
  projectLaunchTotalResults: null,
  projectLaunchTotalPages: null,
  projectLaunchPageIds: [],
  fetchingData: true,
  projectLaunchSearchText: "",
  projectLaunchCurrentPage: 1,
  lauchListResultPerPage: 10,
  projectLaunchStatusFliter: [],
  initialTab: 0,
  tabValues: {},
  projectRenewalsListing: [],
};


const projectLaunchReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_LAUNCH_LIST: {
      return {
        ...state,
        projectLaunchListing: action.payload.results,
        projectLaunchTotalResults: action.payload.total_results,
        projectLaunchTotalPages: action.payload.total_pages,
        projectLaunchPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

        case CHANGE_CURRENT_PROJECT_PAGE: {
          return {
            ...state,
            projectLaunchCurrentPage: action.payload,
          };
        }
    
        case SET_PROJECT_ITEMS_PER_PAGE: {
          return {
            ...state,
            lauchListResultPerPage: action.payload,
          };
        }
     case SEARCH_JOBS: {
          return {
            ...state,
            projectLaunchSearchText: action.payload,
          };
        }

        case PROJECT_STATUS_FILTER: {
          return {
            ...state,
            projectLaunchStatusFliter: action?.payload || [],
          };
        }

         case VIEW_LAUNCH_DETAILS: {
          return {
            ...state,
            launchDetails: action.payload,
          };
        }

      case CHANGE_VIEW_LAUNCH_TAB: {
      return {
        ...state,
        initialTab: action.payload,
      };
    }

     case PROJECT_RENEWAL_LIST: {
          return {
            ...state,
           projectRenewalsListing: action.payload,
           fetchingData: false,
          };
        }
    

    default:
      return state;
  }
};

export default projectLaunchReducer;